var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full"},[(_vm.fullObject && _vm.question)?_c('QuestionBuilderEngine',{staticClass:"full",attrs:{"saving":_vm.saving,"dbObject":_vm.fullObject,"question":_vm.question},on:{"saving":(v) => { _vm.saving = v },"save":_vm.onSave}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }